module.exports = "<span ng-bind=\"getObjValue(option, groupAttr)\"></span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/selector/group-default.html
// module id = 579
// module chunks = 0